/**
 * PLP Star Rating Component
 * Always renders 5 stars. Shows value + stars + (count).
 */
(function () {
  const { html, useMemo } = window.preact;
  var gradientCounter = 0;

  function StarIcon({ filled, half, gradientId }) {
    if (half) {
      return html`
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="${gradientId}">
              <stop offset="50%" stop-color="#F04F36" />
              <stop offset="50%" stop-color="#C2C2C2" />
            </linearGradient>
          </defs>
          <path d="M8 1.12l1.95 3.95 4.36.64-3.16 3.08.75 4.33L8 11.03l-3.9 2.09.75-4.33L1.69 5.71l4.36-.64L8 1.12z" fill="url(#${gradientId})" />
        </svg>
      `;
    }
    return html`
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 1.12l1.95 3.95 4.36.64-3.16 3.08.75 4.33L8 11.03l-3.9 2.09.75-4.33L1.69 5.71l4.36-.64L8 1.12z" fill="${filled ? '#F04F36' : '#C2C2C2'}" />
      </svg>
    `;
  }

  function StarRating({ rating, count }) {
    var r = rating || 0;
    var c = count || 0;
    var uid = useMemo(function () { return 'hs-' + (++gradientCounter); }, []);

    // No reviews → hide the rating but keep the row height so the tile layout
    // (image / title / rating / price) stays aligned across cards.
    if (c <= 0) {
      return html`<div class="plp-rating plp-rating--empty" aria-hidden="true"></div>`;
    }

    var stars = [];
    for (var i = 1; i <= 5; i++) {
      if (r >= i) {
        stars.push(html`<${StarIcon} key=${i} filled=${true} />`);
      } else if (r >= i - 0.5) {
        stars.push(html`<${StarIcon} key=${i} half=${true} gradientId=${uid + '-' + i} />`);
      } else {
        stars.push(html`<${StarIcon} key=${i} filled=${false} />`);
      }
    }

    return html`
      <div class="plp-rating">
        <span class="plp-rating__value">${r.toFixed(1)}</span>
        <div class="plp-rating__stars">${stars}</div>
        <span class="plp-rating__count">(${c})</span>
      </div>
    `;
  }

  window.PlpStarRating = StarRating;
})();
